import { render, staticRenderFns } from "./cpi-countries.vue?vue&type=template&id=0f5f1e73"
import script from "./cpi-countries.vue?vue&type=script&lang=js"
export * from "./cpi-countries.vue?vue&type=script&lang=js"
import style0 from "./cpi-countries.vue?vue&type=style&index=0&id=0f5f1e73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports